module.exports = __webpack_public_path__ + "static/media/bg.36ecc6cb.jpg";